import React, { useState } from 'react'
import { sendPasswordReset } from '../utils/api'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState(null)
  const [message, setMessage] = useState('')

  const handleSubmit = async e => {
    e.preventDefault()
    setStatus(null)
    setMessage('')

    try {
      await sendPasswordReset(email)
      setStatus('success')
      setMessage(
        'If that email exists, you’ll receive reset instructions shortly.'
      )
    } catch (err) {
      setStatus('error')
      setMessage(err.message || 'Something went wrong.')
    }
  }

  return (
    <div className="container mt-5" style={{ maxWidth: '500px' }}>
      <div className="card shadow-sm">
        <div className="card-body">
          <h3 className="card-title mb-4 text-center">Forgot Password</h3>

          {status === 'success' && (
            <div className="alert alert-success" role="alert">
              {message}
            </div>
          )}
          {status === 'error' && (
            <div className="alert alert-danger" role="alert">
              {message}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email Address
              </label>
              <input
                id="email"
                type="email"
                className="form-control"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="btn btn-primary w-100">
              Send Reset Link
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}
